import React from 'react';

/** 将正文中的 **加粗** 转为 <strong>。 */
export default function LegalRichText({ text }) {
  const raw = text == null ? '' : String(text);
  if (!raw.includes('**')) return raw;
  const parts = raw.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}
